import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
export default {
    name: 'propertySchool',
    inject: ['$eventBus'],
    components: {
        mvtShifter,
        mvtCollapse,
    },
    props: ['disableCollapse', 'isActive'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        schools() {
            if (this.dpp.nearbySchools && this.dpp.nearbySchools.length) {
                const levelOrder = { 'P': 1, 'E': 2, 'M': 3, 'H': 4 };
                const schools = this.dpp.nearbySchools.map((item) => {
                    if (item.ncesId && this.dpp.schoolDistricts && this.dpp.schoolDistricts.length) {
                        item.schoolDistrict = this.dpp.schoolDistricts.find((district) => item.ncesId.indexOf(district.ncesId) === 0);
                    }
                    return item;
                });

                return schools.sort((a, b) => {
                    const aMin = Math.min(...a.levelCode.split(',').map(code => levelOrder[code.trim()] || 999));
                    const bMin = Math.min(...b.levelCode.split(',').map(code => levelOrder[code.trim()] || 999));
                    return aMin - bMin;
                });
            }
            return null;
        },
    },
    methods: {
        showSchoolDistrict: function (schoolId) {
            let mspUrl = `${this.glb.appUrl}${this.dpp.geo.cityPath}saz-${schoolId}`;
            window.open(mspUrl, '_blank');
        },
    },
};
